import {AbstractFilter} from './AbstractFilter';
import {FilterValueInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Filter/Value/FilterValueInterface';

class TextValue implements FilterValueInterface{
    private _query: string|null;

    constructor() {
        this._query = null;
    }

    get query(): string {
        return this._query;
    }

    set query(value: string) {
        if (value === '') {
            this.clear();
            return;
        }
        this._query = value;
    }

    clear() {
        this._query = null;
    }

    countValues(): number {
        return this._query ? 1 : 0;
    }

    toGetParam(): any {
        return this._query;
    }

    toServerParam(): any {
        return this._query;
    }

    setGetParam(value: any): void {
        if (typeof value === 'string') {
            this._query = value;
        }
    }
}

export class TextFilter extends AbstractFilter<TextValue> {

    private _value: TextValue|null;

    constructor(id: string, label: string) {
        super(id, label);
        this._value = new TextValue();
    }

    hasValue(): boolean {
        return this._value !== null && this._value.query !== null;
    }

    get value(): TextValue {
        return this._value;
    }

    set value(value: TextValue) {
        this._value = value;
    }

    reset(): void {
        this._value.clear();
    }
}
